import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
const statusStatusCreatedCss = "shcsowj";
const statusStatusBookedCss = "sewm12q";
const statusStatusViewedCss = "sl0hs32";
const statusStatusExpiredCss = "sq0kw1a";
const statusCss = "s1uzqoxy";
export const Status = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    status,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(statusCss, {
    [statusStatusCreatedCss]: status?.toString() === 'created',
    [statusStatusBookedCss]: status?.toString() === 'booked',
    [statusStatusViewedCss]: status?.toString() === 'viewed',
    [statusStatusExpiredCss]: status?.toString() === 'expired'
  }, props.className)}>
      {I18n.t(`publisher.scheduling.shared.statuses.${status}`)}
    </Component>;
});

require("./status.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./status.js");